;(function ($) {

  var mastheadSlider = $('#masthead_slider'),
    howToMenuSlider = $('#how_to_menu_slider');

  $(document).ready(function () {

    $('body').on('click', '.show-hide-button', showHideToggle);

    initAnimatedNumbers();

    initShowHideToggle();

    if ($('body').hasClass('page-template-template-how-to-section')) {
      initHowToMenuSlider(); 
    }
    // if ($('body').hasClass('home')) {
    //   initMastheadSlider()
    // }

    // Client side, this won't affect if the page is cached.
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('mobile') !== -1 || userAgent.indexOf('android') !== -1 ||
        userAgent.indexOf('iphone') !== -1 || userAgent.indexOf('ipad') !== -1 ||
        userAgent.indexOf('blackberry') !== -1 || userAgent.indexOf('windows phone') !== -1 ||
        userAgent.indexOf('kindle') !== -1) {

      // Do something if mobile...

    } else {

      // if ($('body').hasClass('home')) {
      //   initAnimatedNumbers()
      // }

      let mastheadSliderMobile = document.querySelector(".masthead-slider-container.mobile");
      if (mastheadSliderMobile) {
        mastheadSliderMobile.style.display = "none";
      }

      let mastheadSliderDesktop = document.querySelector(".masthead-slider-container.desktop");
      if (mastheadSliderDesktop) {
        mastheadSliderDesktop.style.display = "flow-root";
      }

      if ($('body').hasClass('home')) {
        initMastheadSlider()
      }
    }

  });

  /**
   * Show/Hide Accordion Toggle.
   */
  function showHideToggle() {
    // console.log('showHideToggle');
    var $this = $(this),
      content = $this.siblings('.show-hide-content');

    if (content.hasClass('show')) {
      console.log('close toggle');
      content.removeClass('show');
      $this.removeClass('up-arrow');
      content.attr('aria-hidden', true);
    } else {
      console.log('open toggle');
      content.addClass('show');
      $this.addClass('up-arrow');
      content.attr('aria-hidden', false);
    }
  }

  /**
   * Init the Show/Hide Accordions, Covers NO-JS
   */
  function initShowHideToggle() {
    var showHideContent = $('.show-hide-content'),
      showHideButton = $('.show-hide-button');
    if (showHideContent) {
      showHideContent.removeClass('show');
      showHideContent.attr('aria-hidden', true);
    }
    if (showHideButton) {
      showHideButton.removeClass('minus');
    }
  }

  /**
   * Init the Slider(s) if any are on page.
   */
  function initHowToMenuSlider() {

    // console.log('initHowToMenuSlider');

    if (howToMenuSlider) {

      let initialSlide = howToMenuSlider.find('.initial-slide'),
        initialSlideIndex = initialSlide.data('ht-slide');

      initialSlideIndex = initialSlideIndex ? parseInt(initialSlideIndex) : 0;

      $('#how_to_menu_slider').slick({
        dots: false,
        autoplay: false,
        autoplaySpeed: 5000,
        arrows: true,
        infinite: true,
        pauseOnHover: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        initialSlide: initialSlideIndex,
        accessibility: true,
        speed: 500,
        fade: false,
        cssEase: 'linear',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

  }

  /**
   * Init the Slider(s) if any are on page.
   */
  function initMastheadSlider() {

    if (mastheadSlider) {

      $('#masthead_slider').slick({
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        infinite: true,
        pauseOnHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        speed: 1200,
        fade: true,
        cssEase: 'linear'
      });
    }

  }

  /**
   *
   */
  function initAnimatedNumbers() {

    let featureBucketsAnimated = $('.feature-buckets.animated');

    if (featureBucketsAnimated.length) {
      let waypoints = $('.feature-buckets.animated').waypoint({
        handler: function () {
          animateNumbers();
        },
        offset: '75%'
      })
    }

  }

  /**
   *
   */
  function animateNumbers() {
    // https://www.jqueryscript.net/animation/Simple-jQuery-Plugin-To-Animate-Numeric-Text-Animate-Numbers.html
    $('.counter').each(function (index, item) {
      let $this = $(item),
        countTo = $this.attr('data-count');
      $this.animateNumbers(countTo, true, 4000);
    });
  }

  $(window).load(function () {
    if (Foundation.MediaQuery.atLeast('medium')) {
      initFullResImages();
    }
  });

  /**
   * Looks for any image with data attribute: data-full-res and swaps out the low res version with full res.
   */
  function initFullResImages() {
    // console.log('initFullResImages');
    $('[data-full-res]').each(function (index, item) {
      var $this = $(item),
        fullResURL = $this.attr('data-full-res');


      var image = document.images[index];
      var downloadingImage = new Image();
      downloadingImage.onload = function () {
        $this.css('background-image', 'url(' + fullResURL + ')');
      };
      downloadingImage.src = fullResURL;

    });
  }

  $(window).on('changed.zf.mediaquery', function (event, name) {
    console.log('Breakpoint Watch: ', name);
  });

})(jQuery);